import { render, staticRenderFns } from "./category_twins_left.vue?vue&type=template&id=32de182e&scoped=true&"
import script from "./category_twins_left.vue?vue&type=script&lang=js&"
export * from "./category_twins_left.vue?vue&type=script&lang=js&"
import style0 from "./category_twins_left.vue?vue&type=style&index=0&id=32de182e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de182e",
  null
  
)

component.options.__file = "category_twins_left.vue"
export default component.exports